// IMPORTANT: Polyfills must be imported FIRST
import './polyfills.js';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppKitProvider } from '@reown/appkit/react';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { config, wagmiAdapter, networks } from './lib/wagmi';
import App from './App.jsx';
import './index.css';

const queryClient = new QueryClient();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AppKitProvider
      adapters={[wagmiAdapter]}
      networks={networks}
      projectId={import.meta.env.VITE_REOWN_PROJECT_ID || 'YOUR_PROJECT_ID'}
      themeMode="dark"
      enableAccountView={false}
      enableNetworkView={false}
      enableOnramp={false}
      themeVariables={{
        '--w3m-accent': '#ff5b13',
        '--w3m-background-color': '#0a0a0a',
        '--w3m-container-border-radius': '12px',
        '--w3m-border-radius-master': '12px',
        '--w3m-font-family': '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <WagmiProvider config={config} reconnectOnMount={false}>
        <QueryClientProvider client={queryClient}>
          <HelmetProvider>
            <HashRouter>
              <App />
              <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#1a1a1a',
                  color: '#ffffff',
                  border: '1px solid rgba(255, 91, 19, 0.3)',
                },
                success: {
                  iconTheme: {
                    primary: '#ff5b13',
                    secondary: '#ffffff',
                  },
                },
                error: {
                  iconTheme: {
                    primary: '#ef4444',
                    secondary: '#ffffff',
                  },
                },
              }}
            />
            </HashRouter>
          </HelmetProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </AppKitProvider>
  </StrictMode>
);
